import { atom } from 'jotai';

export const atomSignalSendersOnboarding = atom({
  complete: false,
  origin: '',
});
atomSignalSendersOnboarding.debugLabel = 'atomSignalSendersOnboarding';
